import { useEffect } from "react"
import { MediaLinks } from "../utils/StrapiUtils";

const useSlider = (slideImage:React.RefObject<HTMLImageElement>, images:MediaLinks[]) => {
  let slideCounter = 0;
  useEffect(() => startSlider(), [])

  const startSlider = () => {
    slideImage.current.src = images[0]?.src
  }

  const handleSlide = (slide:number) => {
    slideImage.current.src = images[slide - 1]?.src
    animateSlide()
  }
  const selectSlide = (slide:number) => {
    slideImage.current.src = images[slide]?.src
    animateSlide()
    slideCounter = slide
  }

  const animateSlide = () => {
    slideImage.current.classList.add("fadeIn");
    setTimeout(() => {
      if(!slideImage.current) return;
      slideImage.current.classList.remove("fadeIn");
    }, 700);
  }

  const goToPreviousSlide = () => {
    if (slideCounter === 0) {
      handleSlide(images.length)
      slideCounter = images.length;
    }
    handleSlide(slideCounter)
    slideCounter--;
  }

  const goToNextSlide = () => {
    if (slideCounter === images.length - 1) {
      startSlider()
      slideCounter = -1;
      animateSlide()
    }
    slideImage.current.src = images[slideCounter + 1]?.src
    slideCounter++;
    animateSlide()
  }

  return {goToPreviousSlide, goToNextSlide, selectSlide}
}

export default useSlider
